import React from 'react';
import CAppFilterSelect from '../../../app/components/CAppFilterSelect';
import { useAuthContext } from '../../auth/contexts/AuthContext';
import IUserCompany from '../interfaces/IUserCompany';
import useUserCompanys from '../hooks/useUserCompanys';
import { useNavigate } from 'react-router-dom';
import HAppRoutes from '../../../app/features/routes/helpers/HAppRoutes';
import InvestorRoutes from '../../investor/InvestorRoutes';

const FUserCompanySelect = () => {
	const { companies } = useUserCompanys();
	const auth = useAuthContext();

	const navigate = useNavigate();

	const handleSwitchCompany = (company: IUserCompany) => {
		auth.setCurrentCompany(company);
		navigate(HAppRoutes.getPath(InvestorRoutes.dashboard.tag));
	};

	return (
		<>
			{companies && companies.length > 1 ? (
				<CAppFilterSelect
					className="user-company-select"
					size="small"
					value={auth.currentCompany}
					sx={{ minWidth: '220px' }}
					onChange={(obj: { id: number; name: string } | null) => {
						const company = obj && companies?.find((c) => c.id === obj.id);
						if (company) handleSwitchCompany(company);
					}}
					options={companies.map((x) => ({ id: x.id, name: x.name }))}
				/>
			) : (
				<></>
			)}
		</>
	);
};

export default FUserCompanySelect;
